import { useEffect, useState } from "react";
import { fetchVolunteerSection, VolunteerSection } from "../api/contentful";

export function useVolunteerSection() {
  const [data, setData] = useState<VolunteerSection | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchVolunteerSection()
      .then((res) => setData(res))
      .catch((err) => setError(err.message || "Failed to load volunteer section"))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
